"use client";
import { jsxs as o, jsx as h } from "react/jsx-runtime";
const l = ({
  title: v,
  titleId: a,
  desc: r,
  descId: c,
  ...t
}) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": a,
    "aria-describedby": c,
    ...t,
    children: [
      r ? /* @__PURE__ */ h("desc", { id: c, children: r }) : null,
      v ? /* @__PURE__ */ h("title", { id: a, children: v }) : null,
      /* @__PURE__ */ h(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.3,
          d: "M28.122 8.438a.63.63 0 0 0 .628-.628V3.879a.63.63 0 0 0-.628-.629H24.19a.63.63 0 0 0-.628.628V5.25h-5V3.878c0-.345-.251-.628-.596-.628h-3.932c-.345 0-.597.283-.597.628V5.25h-5V3.878a.63.63 0 0 0-.627-.628H3.879a.63.63 0 0 0-.629.628V7.81a.63.63 0 0 0 .628.628H5.25v5H3.878c-.345 0-.628.251-.628.596v3.932c0 .345.283.596.628.596H5.25v5H3.878a.63.63 0 0 0-.628.628v3.931a.63.63 0 0 0 .628.629H7.81a.63.63 0 0 0 .628-.628V26.75h5v1.372c0 .345.251.628.596.628h3.932c.345 0 .596-.283.596-.628V26.75h5v1.372a.63.63 0 0 0 .628.628h3.931a.63.63 0 0 0 .629-.628V24.19a.63.63 0 0 0-.628-.628H26.75v-5h1.372c.345 0 .628-.251.628-.596v-3.932c0-.345-.283-.596-.628-.596H26.75v-5zM14.688 4.5h2.624v2.688h-2.625V4.5ZM4.5 7.188V4.5h2.688v2.688zm0 10.125v-2.625h2.688v2.624H4.5ZM7.188 27.5H4.5v-2.688h2.688zm10.125 0h-2.625v-2.688h2.624V27.5Zm6.25-3.31v1.31h-5v-1.31c0-.345-.252-.628-.597-.628h-3.932c-.345 0-.597.283-.597.628v1.31h-5v-1.31a.63.63 0 0 0-.627-.628H6.5v-5h1.31c.345 0 .628-.251.628-.596v-3.932c0-.345-.283-.596-.628-.596H6.5v-5h1.31a.63.63 0 0 0 .628-.628V6.5h5v1.31c0 .345.251.628.596.628h3.932c.345 0 .596-.283.596-.628V6.5h5v1.31a.63.63 0 0 0 .628.628h1.31v5h-1.31c-.345 0-.628.251-.628.596v3.932c0 .345.283.596.628.596h1.31v5h-1.31a.63.63 0 0 0-.628.628Zm3.937.622V27.5h-2.688v-2.688zm0-10.125v2.626h-2.688v-2.625H27.5Zm-2.688-7.5V4.5H27.5v2.688h-2.688Z"
        }
      ),
      /* @__PURE__ */ h(
        "path",
        {
          stroke: "currentColor",
          strokeWidth: 0.3,
          d: "M18.625 12.75h-5.25a.624.624 0 0 0-.625.625v5.25a.624.624 0 0 0 .625.625h5.25a.624.624 0 0 0 .625-.625v-5.25a.624.624 0 0 0-.625-.625ZM18 18h-4v-4h4z"
        }
      )
    ]
  }
);
export {
  l as default
};
